import React, {Component} from 'react'
import {connect} from "react-redux";
import { Field, reduxForm } from 'redux-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Dropzone from 'react-dropzone';
import { uploadAvatar } from '../../../actions'


class UploadAvatar extends Component{
    onSubmit(data){
        var body = new FormData();
        if(data.avatar && data.avatar.length > 0){
            data.avatar.forEach(function(file){
                body.append('avatar[]', file);
            });
        }
        this.props.uploadAvatar(body, this.props.userId);
        this.props.toggler();
    }
    renderDropzoneInput(field){
        const files = field.input.value;
        return (
            <div className="dropzone-container">
                {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
                <Dropzone
                    accept="image/jpeg, image/png"
                    className="dropzone"
                    name={field.name}
                    onDrop={( filesToUpload, e ) => field.input.onChange(filesToUpload)}
                >
                    {({ isDragActive, isDragReject }) => {
                        if (isDragReject) {
                            return "Algunos archivos no son compatibles";
                        }
                        return (
                            <div>Haz click o arrastra los archivos que deseas incluir.
                            <p className="small">Solo se aceptan archivos jpg o png.</p>
                        </div>);
                    }}

                </Dropzone>
                {files && Array.isArray(files) && (
                    <ul>
                        { files.map((file, i) => <li key={i}>{file.name}</li>) }
                    </ul>
                )}
            </div>
        );
    }
    render(){
        const {handleSubmit} = this.props;
        return(
            <Modal className="modal-dialog-centered" isOpen={this.props.show} toggle={this.props.toggler}>
            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <ModalHeader toggle={this.props.toggler}>Cambiar imagen de usuario</ModalHeader>
                <ModalBody>
                    <Field
                        name="avatar"
                        component={this.renderDropzoneInput}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                    <Button color="primary" type="submit">Cambiar imagen</Button>{' '}
                </ModalFooter>
            </form>
            </Modal>

        )
    }
}

UploadAvatar = reduxForm({
    form: 'avatarUpload',
})(UploadAvatar);
export default UploadAvatar = connect(null, {uploadAvatar})(UploadAvatar);


// WEBPACK FOOTER //
// ./resources/assets/js/components/settings/user/UploadAvatar.jsx